import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/` — the app root. Everyone lands on their personal landing
 * (`/my`), admins / accountants included; a client lands on the
 * project overview (`/dashboard`) instead.
 */
export const Route = createFileRoute("/_app/")({
  loader: async ({ parentMatchPromise }) => {
    const isCustomer = (await parentMatchPromise).loaderData?.isCustomer;
    throw redirect({ to: isCustomer ? "/dashboard" : "/my" });
  },
});
